export const getPaymentMethodFilter = state => state.paymentMethod.filter
